import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Polls unread message / new-share counts. Shape depends on role:
//  coach:       { role, messages: {pid: n}, shares: {pid: n} }
//  participant: { role, unread_messages: n }
export function useNotifications(intervalMs = 15000) {
  const { user } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!user) { setData(null); return; }
    let active = true;
    const load = async () => {
      try {
        const res = await api.get("/notifications");
        if (active) setData(res.data);
      } catch (e) { /* silent: badges are non-critical */ }
    };
    load();
    const t = setInterval(load, intervalMs);
    return () => { active = false; clearInterval(t); };
  }, [user, intervalMs]);

  return data;
}
